import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonDataService } from '../../services/common-data.service';
import { GraphqlService } from '../../services/graphql.service';

@Component({
  selector: 'app-location-breadcrumb',
  templateUrl: './location-breadcrumb.component.html'
})
export class LocationBreadcrumbComponent implements OnInit {

  constructor(
    public commonDataService: CommonDataService,
    private graphqlService: GraphqlService,
    private router: Router
  ) { }

  @Input() printPreview?: boolean = false;
  @Input() isShowAllInOnePage?: boolean = false;
  currentParagraph: string;
  arrowRightDown: boolean = false;
  crumbData: string[];

  ngOnInit(): void {
    this.commonDataService.navDataContentPage.subscribe(data => {
      if (this.printPreview && this.isShowAllInOnePage) {
        this.crumbData = data.slice(0, 1);
      }
      else if (this.printPreview) {
        this.crumbData = data.slice(0, data.length - 1);
      }
      else {
        this.crumbData = data;
      }
    })
    this.commonDataService.currentParagraphId.subscribe(data => {
      this.currentParagraph = data == "Glossary" ? "" : (data.replace("SafeValue must use [property]=binding: ", "")).replace(" (see https://g.co/ng/security#xss)", "");
      this.arrowRightDown = false;
      if ((data == "" || data == null ) && data != "Glossary") {
        this.arrowRightDown = true;
        /*this.crumbdata = this.crumbdata.slice(0, this.crumbdata.length);*/
      }
      else if (data == "Edit Annotation Id") {
        this.arrowRightDown = false;
        this.currentParagraph = "";
      }
    })
  }
}
